<template>

  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
                      <i class="fa fa-dashboard"></i>จัดการข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
                    </a>
        </li>
        <li class="active">จัดการข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">

              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
              </div>
              <div class="box-body">

                <div class="wrapper_typegroup">
                  <el-table :data="data_table" style="width: 100%">
                    <el-table-column prop="proportion_main_promotion" label="สัดส่วนรายการส่งเสริมการขาย (Pre-Paid และ Post-Paid)" @keypress.native="isNumberKey">
                    </el-table-column>
                    <el-table-column prop="proportion_ontop_promotion" label="สัดส่วนรายการส่งเสริมการขาย (On-top)" @keypress.native="isNumberKey">
                    </el-table-column>
                    <el-table-column label="จัดการ" align="center" width="100" fixed="right" v-if="user_permission.edit">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button
                            size="mini"
                            type="primary"
                            @click="handleEdit(data_table)"
                          >
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>

</template>
<script>
import {mapActions,mapState} from "vuex"
  export default {
    data() {
      return {
        user_permission : {
          edit : false
        }
      }
    },
    mounted(){
      this.list()
      const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_service
      this.user_permission.edit = permission.includes('edit')
    },
    computed:{
      ...mapState({
         data_table:store=>store.ManageService.data_table,
      })
    },
    methods: {
        ...mapActions({
        list :"ManageService/list"
      }),
      handleEdit(row) {
        let setData = {id:row[0].id,proportion_main_promotion:row[0].proportion_main_promotion,proportion_ontop_promotion:row[0].proportion_ontop_promotion}
        this.$router.push({ name: 'Edit_service',params: setData})
      }
    }
  }

</script>
